"use strict";
/* globals module */
/**
 * @module commerceLookupsRecurringCyclePeriodTypeRoute
 * @description Baasic Commerce Lookups RecurringCyclePeriodType Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups RecurringCyclePeriodType Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var __1 = require("../../");
var CommerceLookupsRecurringCyclePeriodTypeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsRecurringCyclePeriodTypeRoute, _super);
    function CommerceLookupsRecurringCyclePeriodTypeRoute(basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute = basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/recurring-cycle-period-types/{?searchQuery,page,rpp,sort,embed}';
        _this.getRoute = 'commerce/lookups/recurring-cycle-period-types/{id}/{?embed}';
        _this.createRoute = 'commerce/lookups/recurring-cycle-period-types';
        _this.updateRoute = 'commerce/lookups/recurring-cycle-period-types/{id}';
        _this.deleteRoute = 'commerce/lookups/recurring-cycle-period-types/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsRecurringCyclePeriodTypeRoute.prototype, "batch", {
        get: function () {
            return this.basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce customer-payment-methods route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.get();
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.create();
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.update(data);
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.delete(data);
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsRecurringCyclePeriodTypeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsRecurringCyclePeriodTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsRecurringCyclePeriodTypeBatchRoute !== "undefined" && __1.CommerceLookupsRecurringCyclePeriodTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsRecurringCyclePeriodTypeRoute);
    return CommerceLookupsRecurringCyclePeriodTypeRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsRecurringCyclePeriodTypeRoute = CommerceLookupsRecurringCyclePeriodTypeRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
